export default __webpack_public_path__ + "static/media/img-empty.b5b59d2e.svg";